module.exports = __webpack_public_path__ + "img/sparking-change-firefly.117be5ea.png";